import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=8b05d12a&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"
import style0 from "./Phone.vue?vue&type=style&index=0&id=8b05d12a&prod&lang=scss&scoped=true"
import style1 from "./Phone.vue?vue&type=style&index=1&id=8b05d12a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b05d12a",
  null
  
)

export default component.exports